import { Nobles } from '../../lib/anuket';
import { connectStream } from '../../lib/bastetjs/utils/connectStream';
import React from 'react';
import PropTypes from 'prop-types';
import { styles } from './styles';

export const RaceDistancesComponent = (props) => {
  const {
    fetching,
    result,
    t
  } = props;

  const {
    isLoading,
    races = [],
  } = result;

  const showLoading = fetching || isLoading;

  const raceNames = races.reduce((acc, curr) => {
    !acc.includes(curr.raceName) && acc.push(curr.raceName);
    return acc;
  }, []);

  if ((raceNames.length < 1) && !showLoading) {
    return null;
  }

  return (
    <div style={styles.container(showLoading)} >
      <div style={styles.title} id={'race-distances-title'}>
        {t('Race Distances')}
      </div>
      {
        raceNames.map((name) => (
          <div style={styles.name} key={name} className={'race-distances'}>
            {name}
          </div>
        ))
      }

      {
        // Loading placeholder
      }
      <div style={styles.loadingContainer(showLoading)}>
        <div style={styles.loadingTitle}/>
        <div style={styles.loadingDistance}/>
        <div style={styles.loadingDistance}/>
        <div style={styles.loadingDistance}/>
      </div>
    </div>
  );
};

RaceDistancesComponent.propTypes = {
  result: PropTypes.object,
  t: PropTypes.func
};

RaceDistancesComponent.defaultProps = {
  result: {isLoading: true}
};


export const RaceDistances = connectStream({
  result: ({ event }) => {
    const athlinksId = event.athlinksId;
    return Nobles.RacesNoble.getAthlinksCourses(athlinksId);
  }
})(RaceDistancesComponent);
